module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-Bold.405ce2e7.woff";